import { render, staticRenderFns } from "./CardSmall.vue?vue&type=template&id=8cf15688&scoped=true&"
import script from "./CardSmall.vue?vue&type=script&lang=js&"
export * from "./CardSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf15688",
  null
  
)

export default component.exports